import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetUserProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type GetUserProfileQuery = {
  __typename?: 'query_root';
  container_insights_users_by_pk?: {
    __typename?: 'container_insights_users';
    avatar?: string | null;
    company: string;
    currency?: string | null;
    email: string;
    first_name?: string | null;
    id: string;
    last_name?: string | null;
    locale?: string | null;
    role: string;
  } | null;
};

export const GetUserProfileDocument = gql`
  query GetUserProfile($id: String!) {
    container_insights_users_by_pk(id: $id) {
      avatar
      company
      currency
      email
      first_name
      id
      last_name
      locale
      role
    }
  }
`;

export function useGetUserProfileQuery(
  options: Omit<Urql.UseQueryArgs<GetUserProfileQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetUserProfileQuery, GetUserProfileQueryVariables>({
    query: GetUserProfileDocument,
    ...options,
  });
}
